const blobBackgroundObject = document.querySelectorAll(
	".is-style-blob-background"
);

if(blobBackgroundObject.length) {
	blobBackgroundObject.forEach((group) => {
		const element = document.createElement("div");
		const themeUrl = wkScriptVars.theme_url;
		const path = themeUrl + "/assets/dist/lotties/blob.json";

		element.classList.add("lottie-player");
		element.dataset.random = "true";
		element.dataset.path = path;
		group.appendChild(element);
	});
}
